import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Link} from 'shells/link/link';
import {Modal} from 'shells/modal/modal';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import styles from './email-onboarding-modal.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    entityType: string;
    entityUrl: string | null | undefined;
};

export class EmailNoAddressesModal extends React.PureComponent<Props> {
    render() {
        return (
            <Modal
                onClose={this.props.onClose}
                canClickOutsideToClose={true}
                closeButton={false}
                isOpen={this.props.isOpen}
                noPadding={true}
                maxHeight={500}
            >
                <OnboardingPage
                    type='singlePage'
                    buttonText='Got it'
                    artImage={<Art />}
                    bodyComponent={getBody(this.props.entityType, this.props.entityUrl)}
                    artBackgroundColor={colors.plumLt}
                    onClose={this.props.onClose}
                />
            </Modal>
        );
    }
}

const getBody = (entityType: string, entityUrl?: string | null) => (
    <OnboardingBody title={`Oops, this ${entityType} has no email addresses!`}>
        <div>
            <p>
                There are no email addresses associated with this {entityType}. Please add an email
                address and try again!
            </p>
            {entityUrl ? (
                <Link variant='primary' href={entityUrl}>
                    View {entityType} »
                </Link>
            ) : undefined}
        </div>
    </OnboardingBody>
);
const Art = () => (
    <div className={styles.art}>
        <img
            alt=''
            src='/include/images/email-drip/email-onboarding_2x.png'
            className={styles['large-icon']}
        />
    </div>
);
